import { Component, Inject, OnInit, TemplateRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import * as CONSTANT from "src/app/services/constants"
import swal from "sweetalert2";
import { ExcelService } from "src/app/services/excel.service";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Location, LocationStrategy } from "@angular/common";
import { APP_BASE_HREF } from "@angular/common";
import { environment } from "../../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { HttpParams } from "@angular/common/http";
import { chatEnvironment } from "src/environments/chatEnvironment";

@Component({
  selector: "app-notes",
  templateUrl: "./notes.component.html",
  styleUrls: ["./notes.component.css"]
})
export class NotesComponent implements OnInit {
  userID: any;
  userId;
  jobID;
  noteData: any;
  allData: any;
  allListing: any = [];
  arrayUrl: any = [];
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  environment = environment.apiUrl;
  currentPage = 1;
  pagination = { limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: "" }
  search = "";
  closeSearch: boolean = false;
  // filter
  isStatus;
  filterApplied: boolean = false;
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  links;
  // form
  form: FormGroup;
  saveNoteForm: FormGroup;
  listingData: any = [];
  messageList: any = [];
  // social link
  public link: string = "";
  public urlHeader: string = "";
  // mail
  showError: boolean = false;
  mailSendForm: FormGroup;
  mailForwardForm: FormGroup;
  templateData: any = [];
  actionType: any;
  userName: any;
  jobtitles: any;
  page: any;
  applicantId:any;
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  
  constructor(private modalService: BsModalService, public route: ActivatedRoute, private router: Router, private api: AdminService, private formBuilder: FormBuilder, private excelService: ExcelService, private db: AngularFireDatabase, private afAuth: AngularFireAuth, private location: Location, private locationStrategy: LocationStrategy, private toastrService: ToastrService) {
    this.form = this.formBuilder.group({
      id: [""],
      userId: [""],
      note: ["", Validators.compose([Validators.minLength(3), Validators.maxLength(2000)])]
    })
    this.saveNoteForm = this.formBuilder.group({
      userId: [""],
      status: [""],
      id: [""],
      jobPostId: [""],
      note: ["", Validators.compose([Validators.required,Validators.minLength(3), Validators.maxLength(2000)])]
    })

    this.mailSendForm = this.formBuilder.group({
      userId: ["", Validators.compose([Validators.required])],
      toEmail: ["", Validators.compose([Validators.required, Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      subject: ["", Validators.compose([Validators.required])],
      isType: [""],
      message: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(2000)])]
    })
    this.mailForwardForm = this.formBuilder.group({
      userId: ["", Validators.compose([Validators.required])],
      toEmail: ["", Validators.compose([Validators.required, Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      jobTitle: ["", Validators.compose([Validators.required])],
      subject: ["", Validators.compose([Validators.required])],
      candidate: ["", Validators.compose([Validators.required])],
      isType: [""],
      message: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(2000)])]
    })
  }

  ngOnInit(): void {
    this.userID = this.route.snapshot.paramMap.get("id");
    this.userId = this.route.snapshot.queryParamMap.get("id");
    this.applicantId = this.route.snapshot.queryParamMap.get("applicantId");
    console.log(this.applicantId,"------applicantId-----------")
    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
    });
    this.arrayUrl = this.router.url.split("/")
    this.urlHeader = this.arrayUrl[2];
    this.jobID = this.arrayUrl[this.arrayUrl.length - 3];
    this.getDetail();
    this.getData();
    this.environment + apiUrl._getJobsUser + "/" + this.jobID + "/" + this.userID;
    this.link = window.location.href
  }

  backToJob() {
    this.router.navigate(['jobs'], { queryParams: { page: this.page } })
  }
  // detail
  getDetail() {
    this.api.getDatas(apiUrl._getJobsUser + "/" + this.jobID + "/" + this.userID)
      .subscribe(async (res) => {
        this.allData = res.data;
        this.links = this.allData?.user?.email;
        this.saveNoteForm.patchValue({
          userId: this.allData.user?.id,
          status: this.allData.listing?.status,
          note: this.allData.listing?.note,
          id: this.applicantId,
          jobPostId: this.allData?.jobDetail?.jobPostId
        })
      })
  }


  // open model
  open(sendMail: TemplateRef<any>, data) {
    this.mailSendForm.patchValue({
      userId: data?.user?.id,
      toEmail: data?.user?.email,
      isType: 0,
    })
    this.getTemplate();
    this.modalRef = this.modalService.show(
      sendMail,
      Object.assign({}, this.config, { class: "modal-lg addModal" })
    );
  }

  getTemplate() {
    let params = new HttpParams();
    params = params.append("skip", '1');
    params = params.append("limit", '100');
    this.api.getData(apiUrl._getTemplate, params)
      .subscribe(async (res) => {
        this.templateData = res.data.data;
        this.templateData.map((actionName) => {
          if (actionName.action == 1) {
            actionName['actionType'] = "Shortlisted"
          } else if (actionName.action == 2) {
            actionName['actionType'] = "Rejected"
          } else if (actionName.action == 3) {
            actionName['actionType'] = "On Hold"
          } else if (actionName.action == 4) {
            actionName['actionType'] = "BV not cleared"
          } else if (actionName.action == 5) {
            actionName['actionType'] = "Hired"
          }

        })
      })
  }

  onTemplateTypeSelect(event) {
    if (event.target.value == -1) {
      this.mailSendForm.patchValue({
        subject: "",
        message: "",
      })
    } else {
      this.mailSendForm.patchValue({
        subject: this.templateData[event.target.value].subject,
        message: this.templateData[event.target.value].description,
      })
    }
  }

  onSendMail() {
    if (this.mailSendForm.valid) {
      this.api.postData(apiUrl._toMailSend, this.mailSendForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.mailSendForm.reset()
        this.toastrService.success("", "Email successfully sent to candidate.")
      })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  }
  // open model
  openModal(forwordMail: TemplateRef<any>, allData) {
    this.userName = allData?.user?.name
    this.mailForwardForm.patchValue({
      userId: allData?.user?.id,
      jobTitle: allData.job?.jobTitle,
      candidate: allData?.user?.email,
      isType: 0,
    })
    this.modalRef = this.modalService.show(
      forwordMail,
      Object.assign({}, this.config, { class: "modal-md addModal" })
    );
  }
  onForwardMail() {
    if (this.mailForwardForm.valid) {
      this.api.postData(apiUrl._forwardMail, this.mailForwardForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.mailForwardForm.reset()
        this.toastrService.success("", "Candidate details successfully forwarded")
      })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  }
  // data
  getData() {
    let params = new HttpParams();
    params = params.append("userId", this.userID);
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }

    if (this.isStatus != null) {
      params = params.append("filter", this.isStatus);
    }
    this.api.getData(apiUrl._getUserAllNotes, params)
      .subscribe(async (res) => {
        this.pagination.totalItems = res.data.count;
        this.allListing = res.data.allNotes;
      })
  }


  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getData();
  }
  searchFun() {
    this.currentPage = 1;
    this.pagination.skip = 0;
    this.closeSearch = true;
    this.getData();
  }
  clearSearch() {
    this.search = "";
    this.closeSearch = false;
    this.pagination.skip = 0;
    localStorage.removeItem("type-redirect");
    this.getData();
  }
  // filter

  filterApply(event) {
    if (event.target.value == 0) {
      this.isStatus = 0
      this.filter()
    } else if (event.target.value == 1) {
      this.isStatus = 1
      this.filter()
    } else {
      this.getData()
    }
  }
  filter() {
    if (this.isStatus != null) {
      this.filterApplied = true
      this.pagination.skip = 0;
      this.currentPage = 1;
      this.getData()
    } else {
      this.getData()
    }
  }

  back() {
    let page = this.page
    if (this.urlHeader == "applicant") {
      // this.router.navigateByUrl(`/jobs/applicant/${this.jobID}`);
      this.router.navigate([`/jobs/applicant/` + this.jobID], { queryParams: { page: page } });
    } else {
      // this.router.navigateByUrl(`/jobs/suggested/${this.jobID}`);
      this.router.navigate([`/jobs/suggested/` + this.jobID], { queryParams: { page: page } });
    }
  }
  activity() {
    let page = this.page
    if (this.urlHeader == "applicant") {
      // this.router.navigateByUrl(`/jobs/applicant/${this.jobID}/activity/${this.userID}`);
      this.router.navigate([`/jobs/applicant/${this.jobID}/activity/${this.userID}`], { queryParams: { page: page,applicantId:this.applicantId } });
    } else {
      // this.router.navigateByUrl(`/jobs/suggested/${this.jobID}/activity/${this.userID}`);
      this.router.navigate([`/jobs/suggested/${this.jobID}/activity/${this.userID}`], { queryParams: { page: page,applicantId:this.applicantId } });
    }
  }
  profile() {
    let page = this.page
    if (this.urlHeader == "applicant") {
      this.router.navigate([`/jobs/applicant/${this.jobID}/appdetail/`], { queryParams: { userId: `${this.userID}`, page: page,applicantId:this.applicantId } });
    } else {
      this.router.navigate([`/jobs/suggested/${this.jobID}/appdetail/`], { queryParams: { userId: `${this.userID}`, page: page,applicantId:this.applicantId } });
    }
  }
  // edit
  //notes model
  noteStatus(event, data, addMore: TemplateRef<any>) {
    this.noteData = data;
    this.form.patchValue({
      id: this.noteData.id,
      userId: this.noteData.userId,
      note: this.noteData.note,
    })
    this.modalRef = this.modalService.show(
      addMore,
      Object.assign({}, this.config, { class: "modal-sm addModal" })
    );
  }
  onSubmit() {
    const data = {
      "id": this.noteData.id,
      "userId": this.noteData.userId,
      "note": this.form.value.note,
    }
    this.api.putData(apiUrl._updateNotes, data).subscribe(res => {
      this.toastrService.success("", "Note Sent Successfully!");
      this.modalRef?.hide();
      this.getData();
    })
  }

  // delete
  deleteStatus(id) {
    let text = "<p>Are you sure you want to discard this job?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "id": id,
          "userId": this.userID,
        }
        this.api.deleteData(apiUrl._deleteNotes, data).subscribe(res => {
          this.getData();
        })
      }
    });
  }

  // add fav
  addFav(event, number, allData) {

    let favourite;
    let text;
    let jobId;
    if (allData?.jobDetail != null) {
      jobId = allData?.jobDetail?.jobPostId
    } else {
      jobId = allData?.job?.id
    }
    if (number == 0) {
      favourite = 1;
      text = "<p>Are you sure you want to mark this user favourite?</p>";
    } else {
      favourite = 0;
      text = "<p>Are you sure you want to mark this user un-favourite?</p>";
    }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": this.userID,
          "jobPostId": jobId,
          "favourite": favourite,
          "isType": 0,
        }
        this.api.postData(apiUrl._addFavourite, data).subscribe(res => {
          this.getDetail();
        })
      }
    });
  }
  // hide
  hideUser() {
    let text = "<p>Are you sure you want to hide this user?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": this.userID,
          "jobPostId": this.jobID,
          "isType": 0,
        }
        this.api.postData(apiUrl._getHide, data).subscribe(res => {
          this.getData();
          this.router.navigateByUrl(`/jobs/applicant/${this.jobID}`);
        })
      }
    });
  }
  //save note
  saveNotes(event, data, saveNote: TemplateRef<any>) {

    let userData = data.user;
    console.log(userData);
    // this.saveNoteForm.patchValue(userData);
    this.modalRef = this.modalService.show(
      saveNote,
      Object.assign({}, this.config, { class: "modal-sm addModal" })
    );
  }
  onSaveNote() {
    if (this.saveNoteForm.valid) {
      this.api.putData(apiUrl._statusUpdate, this.saveNoteForm.value).subscribe(res => {
        this.toastrService.success("", "Note Sent Successfully!");
        this.modalRef?.hide();
        this.getDetail();
      })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
    
  }

  close() {
    this.modalRef?.hide();
  }


  downloadUser(id) {
    const data = {
      userId: id,
    }
    this.api.postData(apiUrl._downloadRecruiterResume, data).subscribe(
      pdf => {
        window.open(pdf.data.url);
        this.modalRef?.hide();
      },
      err => {
        console.log("err->", err);
      }
    );

  }
  //chat

  openChatView(data) {
    var job_id = data.job?.id;
    var user_id = data.user?.id;
    var user_pic = data.user?.profileImage;
    var user_name = data.user?.name;
    var company_name = data.job?.companyName;
    var company_pic = data.job?.profileImage;
    var chatDiologId = data?.job?.id + ',' + data.user?.id;
    /////////////////////////
    var userNameArr = {};
    userNameArr[job_id] = company_name;
    userNameArr[user_id] = data.user?.name;

    var blockStatus = {};
    blockStatus[job_id] = 0;
    blockStatus[user_id] = 0;

    let unread_count = {}
    unread_count[job_id] = 0;
    unread_count[user_id] = 0;

    var clearChatTime = {};
    clearChatTime[job_id] = new Date().getTime();
    clearChatTime[user_id] = new Date().getTime();

    //////////////////
    var lastMessageArr = {};
    lastMessageArr[job_id] = '';
    lastMessageArr[user_id] = '';

    var picArr = {};
    picArr[job_id] = company_pic ? company_pic : "";
    picArr[user_id] = data.user?.profileImage ? data.user?.profileImage : "";
    this.db.list(`${this.firebaseChats}`,
      query => query
        .orderByChild("chat_dialog_id")
        .equalTo(chatDiologId)
        .limitToLast(10)
    ).valueChanges().subscribe(list => {
      this.messageList = list ? list : [];
      /////////////
      if (list.length == 0) {
        var chatDialog = this.db.object(`${this.firebaseChats}/${chatDiologId}`).set({
          "chat_dialog_id": chatDiologId.toString().trim(),
          "job_id": job_id.trim(),
          "user_id": user_id.trim(),
          "name": userNameArr,
          "last_message_time": new Date().getTime(),
          "last_message_type": 0,
          "last_message_sender_id": user_id.trim(),
          "last_message": lastMessageArr,
          "last_message_id": '',
          "unread_count": unread_count,
          "block_status": blockStatus,
          "clear_chat_time": clearChatTime,
          "user_name": user_name,
          "job_pic": company_pic,
          "pic": picArr,
          "company_name": company_name
        });
        let dialogArr = {}
        dialogArr[chatDiologId] = chatDiologId;
        //dialogArr[chatDiologId] = chatDiologId;

        var chatDialog11212 = this.db.object(`${this.firebaseUsers}/${user_id}`).update({
          "chat_dialog_ids": dialogArr
        });
        var chatDialog112 = this.db.object(`${this.firebaseUsers}/${job_id}`).update({
          "chat_dialog_ids": dialogArr
        });
        this.router.navigateByUrl('message/message-detail/' + job_id);
      } else {
        this.router.navigateByUrl('message/message-detail/' + job_id);
      }
    });
  }
}
